import { Injectable } from '@angular/core';
// import { SwalPortalTargets, SweetAlert2LoaderService } from "@sweetalert2/ngx-sweetalert2";
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  public show(data: SweetAlertOptions): Promise<SweetAlertResult> {
    return Swal.fire({
      ...data,
      background: '#0B2634',
      color: '#fff',
      confirmButtonColor: '#00C08B',
      confirmButtonText: `<span style='color: #000'>${data.confirmButtonText} <i class='fa fa-arrow-right'></i></span>`,
    });
  }

  public showConfirm(data: SweetAlertOptions): Promise<SweetAlertResult> {
    return Swal.fire({
      ...data,
      background: '#0B2634',
      color: '#fff',
      confirmButtonColor: '#00C08B',
      confirmButtonText: `<span style='color: #000'>${data.confirmButtonText} <i class='fa fa-arrow-right'></i></span>`,
    });
  }

  public showPersonalizado(data: SweetAlertOptions): Promise<SweetAlertResult> {
    return Swal.fire({
      ...data,
      background: '#0B2634',
      color: '#fff',
    });
  }
}
